import React from 'react'
import { blogPostListingPaginationInterface } from 'common/types/entities/BlogPostListingInterface'
import PaginationLinkUi from './ui/PaginationLinkUi'
import { publisherFontAwesomeIconsEnum } from 'common/constants/fontAwesomeConst'

type PaginationArrowProps = {
  href: string
  left?: boolean
  right?: boolean
} & blogPostListingPaginationInterface

function PaginationArrow({
  href,
  left,
  right,
  paginationActiveColor,
  mobilePaginationActiveColor,
  paginationActiveBackgroundColor,
  mobilePaginationActiveBackgroundColor,
  paginationInactiveColor,
  mobilePaginationInactiveColor,
  paginationInactiveBackgroundColor,
  mobilePaginationInactiveBackgroundColor,
}: PaginationArrowProps) {
  return (
    <>
      {left && (
        <PaginationLinkUi
          href={href}
          paginationActiveColor={paginationActiveColor}
          mobilePaginationActiveColor={mobilePaginationActiveColor}
          paginationActiveBackgroundColor={paginationActiveBackgroundColor}
          mobilePaginationActiveBackgroundColor={
            mobilePaginationActiveBackgroundColor
          }
          paginationInactiveColor={paginationInactiveColor}
          mobilePaginationInactiveColor={mobilePaginationInactiveColor}
          paginationInactiveBackgroundColor={paginationInactiveBackgroundColor}
          mobilePaginationInactiveBackgroundColor={
            mobilePaginationInactiveBackgroundColor
          }
        >
          <i className={publisherFontAwesomeIconsEnum.ChevronLeftSolid} />
        </PaginationLinkUi>
      )}
      {right && (
        <PaginationLinkUi
          href={href}
          paginationActiveColor={paginationActiveColor}
          mobilePaginationActiveColor={mobilePaginationActiveColor}
          paginationActiveBackgroundColor={paginationActiveBackgroundColor}
          mobilePaginationActiveBackgroundColor={
            mobilePaginationActiveBackgroundColor
          }
          paginationInactiveColor={paginationInactiveColor}
          mobilePaginationInactiveColor={mobilePaginationInactiveColor}
          paginationInactiveBackgroundColor={paginationInactiveBackgroundColor}
          mobilePaginationInactiveBackgroundColor={
            mobilePaginationInactiveBackgroundColor
          }
        >
          <i className={publisherFontAwesomeIconsEnum.ChevronRightSolid} />
        </PaginationLinkUi>
      )}
    </>
  )
}

export default PaginationArrow
